<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getList">
    <!-- <f7-navbar :no-shadow="true">
      <f7-nav-title>人力市场</f7-nav-title>
    </f7-navbar> -->
    <div>
      <f7-swiper :params="{slidesPerView: 1, spaceBetween: 0,
          observer: true, observeParents: true}">
          <f7-swiper-slide>
            <f7-link href="#">
              <div style="height: 8rem;">
                <img width="100%" height="100%" src="@/assets/img/bid-banner.png" />
              </div>
            </f7-link>
          </f7-swiper-slide>
      </f7-swiper>
    </div>
    <div class="has-content">
      <div class="menu-area">
        <div class="menu-row">
          <f7-link href="/bid/projectList">
            <div class="link-menu">
              <img src="@/assets/img/zhaohuo.png" style="width: 2rem; height: 2rem;">
              <div style="padding-top: 0.5rem;">找活</div>
            </div>
          </f7-link>
          <f7-link href="/bid/teamList">
            <div class="link-menu">
              <img src="@/assets/img/paihangbang.png" style="width: 2rem; height: 2rem;">
              <div style="padding-top: 0.5rem;">找队伍</div>
            </div>
          </f7-link>
          <f7-link href="/bid/specWorkerList">
            <div class="link-menu">
              <img src="@/assets/img/rencaizhaopin.png" style="width: 2rem; height: 2rem;">
              <div style="padding-top: 0.5rem;">找人才</div>
            </div>
          </f7-link>
          <f7-link href="/bid/workerList">
            <div class="link-menu">
              <img src="@/assets/img/gongyouzhaomu.png" style="width: 2rem; height: 2rem;">
              <div style="padding-top: 0.5rem;">找工友</div>
            </div>
          </f7-link>
        </div>
      </div>
    </div>
    <div class="divider-row">&nbsp;</div>
    <div class="has-content" style="padding-top: 0rem; padding-bottom: 0rem;">
      <div class="toolbar tabbar">
        <div class="toolbar-inner" style="padding: 0rem 0rem;">
          <a href="#bidProject" class="tab-link tab-link-active" @click="tabIndex = 0">
            <span style="font-size: 0.8rem;">任务招标信息</span>
          </a>
          <a href="#bidTeam" class="tab-link" @click="tabIndex = 1">
            <span style="font-size: 0.8rem;">人才招聘信息</span>
          </a>
          <a href="#bidWorker" class="tab-link" @click="tabIndex = 2">
            <span style="font-size: 0.8rem;">工友招募信息</span>
          </a>
          <span :class="`tab-link-highlight${tabIndex}`"></span>
        </div>
      </div>
      <f7-tabs>
        <f7-tab id="bidProject" tab-active>
          <div style="text-align: center; padding: 0.5rem 0.5rem;" v-if="projectList.length === 0">
            暂无任务招标信息
          </div>
          <div v-else>
            <div v-for="(item, index) in projectList" :key="item.id">
              <bid-project :project="item"></bid-project>
              <div class="line-horizontal" v-if="index !== projectList.length - 1">&nbsp;</div>
            </div>
          </div>
        </f7-tab>
        <f7-tab id="bidTeam">
          <div style="text-align: center; padding: 0.5rem 0.5rem;">
            暂无人才招聘信息
          </div>
        </f7-tab>
        <f7-tab id="bidWorker">
          <div style="text-align: center; padding: 0.5rem 0.5rem;">
            暂无工友招募信息
          </div>
        </f7-tab>
      </f7-tabs>
    </div>
  </f7-page>
</template>
<script>
import { getBidList } from '@/api/bid';
import BidProject from '@/components/BidProject';

export default {
  components: {
    BidProject,
  },
  data() {
    return {
      tabIndex: 0,
      projectList: [],
      teamList: [],
      workerList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    getList() {
      getBidList().then((result) => {
        if (result.code === 0) {
          this.projectList = (result.data || []).map(item => Object.assign(item, {
            pathDisplay: false,
          }));
          // (result.data || []).forEach((item) => {
          //   const pos = this.projectList.findIndex(w => w.id === item.id);
          //   if (pos < 0) {
          //     this.projectList.push(Object.assign(item, {
          //       pathDisplay: false,
          //     }));
          //   } else {
          //     this.projectList.splice(pos, 1, item);
          //   }
          // });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .menu-area {
     padding: 0.5rem 0.5rem;
     text-align: center;
  }

  .menu-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .link-menu {
    width: 4.5rem;
    height: 4.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .divider-row {
    font-size: 0.5rem;
    height: 0.5rem;
    width: 100%;
  }

  .tab-link-highlight0 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 33.333333%;
    transform: translate3d(0%, 0px, 0px);
  }

  .tab-link-highlight1 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 33.333333%;
    transform: translate3d(100%, 0px, 0px);
  }


  .tab-link-highlight2 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 33.333333%;
    transform: translate3d(200%, 0px, 0px);
  }

</style>



// WEBPACK FOOTER //
// src/pages/bid/list.vue